import CustomersPage from './components/CustomersPage';
import useCustomersController from './controllers/useCustomersController';

const Customers = () => {
    const controller = useCustomersController();

    return <CustomersPage {...controller} />;
};

export default Customers;
